import React from "react";

export const GearIcon = () => (
    <i className="icon ion-ios7-gear-outline" />
);
